import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'

import router from './router'

import "@/assets/scss/app.scss";
import i18n from './i18n'

import store from '@/state/store'
import './assets/css/style.css'

import { configureFakeBackend } from './helpers/fake-backend';



if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
  // setup fake backend
  configureFakeBackend();
}

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
